import type { MapProvider } from "./map-url";

/**
 * Browser-only. Falls back to "google" off the browser, so a server render and the first client
 * render agree; call it after mount to pick up the real platform without a hydration mismatch.
 */
export const detectMapProvider = (): MapProvider => {
	if (typeof navigator === "undefined") {
		return "google";
	}

	// Typed here because this package compiles without the DOM lib; all three are absent off-browser.
	const nav = navigator as { userAgent?: string; platform?: string; maxTouchPoints?: number };

	// iPadOS reports a desktop platform, so touch points are what separate an iPad from a Mac.
	const isIOS =
		/iPad|iPhone|iPod/.test(nav.userAgent ?? "") || (nav.platform === "MacIntel" && (nav.maxTouchPoints ?? 0) > 1);

	return isIOS ? "apple" : "google";
};
